import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faHeart } from '@fortawesome/free-solid-svg-icons'
import TimeAgo from 'react-timeago'
import defaultFormatter from 'react-timeago/lib/defaultFormatter'

import donationAmount from 'src/flp/donations/donationAmount'
import renderI18nTemplate from 'src/utils/renderI18nTemplate'

// Single row in the donor feed. Tailwind port of donate_v6/goal/Donation.jsx,
// with the BS5 `.initials` / `text-body-secondary` / `h6` vocabulary
// rewritten to v7's brand-anchored utilities. Anonymized donors and
// donors who chose to display a business name (rather than their
// own initials) get a heart icon in the avatar circle instead of
// initials.
//
// Sentence assembly goes through the goal.donor_donated template so
// translations can reorder donor and amount around the verb. The
// outer wrapper sets text-gray-600 for the connector ("donated"),
// and the donor / amount JSX nodes opt back into a darker shade
// for emphasis.

const Donation = ({ i18n, order }) => {
  const showHeart = order.has_business_name || order.anonymized

  const donorName = (
    <span className="font-semibold text-gray-900">{order.donor_name}</span>
  )
  const amount = (
    <span className="whitespace-nowrap">
      <span className="font-semibold text-gray-900">{donationAmount(order)}</span>
      {order.currency.iso_code !== 'USD' && (
        <span className="text-sm">
          {' '}{order.currency.iso_code}
        </span>
      )}
    </span>
  )

  return (
    <div className="flex items-center gap-3">
      {/* Avatar wrapper — `flex-none` keeps the circle from squishing
          when long names push the row's text content. */}
      <div className="flex-none w-10 h-10 rounded-full bg-brand-100 text-brand-700 flex items-center justify-center font-semibold">
        {showHeart ? <FontAwesomeIcon icon={faHeart} /> : order.donor_initials}
      </div>
      <div className="flex-1 min-w-0">
        <div className="text-gray-600">
          {renderI18nTemplate(i18n.t('goal.donor_donated'), {
            donor: donorName,
            amount,
          })}
        </div>
        <div className="text-sm text-gray-500 flex flex-wrap gap-x-2 mt-0.5">
          <span>
            <TimeAgo
              date={order.created_at}
              formatter={(value, unit, suffix) =>
                unit === 'second'
                  ? i18n.t('goal.timeago_just_now')
                  : defaultFormatter(value, unit, suffix)
              }
            />
            {order.is_pending_pledge && (
              <span className="text-brand-600">
                {' '}{i18n.t('goal.donation_pending')}
              </span>
            )}
          </span>
          {order.is_match && (
            <span className="text-brand-600 whitespace-nowrap">
              {i18n.t('goal.donation_match')}
            </span>
          )}
        </div>
      </div>
    </div>
  )
}

export default Donation
